/* eslint-disable no-prototype-builtins */
/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
export const prepareSiteMessageWithLink = (messageText: any, linkText: any, linkValue: any, argument: any) => {
    return messageText?.toString()?.replace(argument, `<a href="${linkValue}">${linkText.toString()}</a>`);
};

export const handleSiteMessageLinkClick = (e: any, callback: any) => {
    e.preventDefault();

    let el = e.target;

    while (el && el !== e.currentTarget && el.tagName !== "A") {
        el = el.parentNode;
    }

    if (el && el.tagName === "A") {
        callback && callback();
    }
};

export const doScroll = (scrollToTop = false) => {
    setTimeout(() => {
        const selector = document.querySelector("[aria-invalid='true']");

        if (selector) {
            selector.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });

            return;
        }

        if (scrollToTop) {
            window.scrollTo(0, 0);
            return;
        }

        doScroll(scrollToTop);
    }, 500);
};

export const isProductInActive = (product: any) => {
    return (
        (product?.hasOwnProperty("isActive") && !product.isActive) ||
        (product?.hasOwnProperty("isActiveProduct") && !(product as any).isActiveProduct)
    );
};

export const isMobileWidth = () => window.outerWidth < 768;

export const getPathFromUrl = (url: any) => {
    return url.split(/[?#]/)[0];
};

export const checkPostalCode = (country: string, postalCode: string) => {
    let error = false;

    switch (country) {
        case "US":
        case "MX":
            if (!/^\d{5}(?:[-\s]\d{4})?$/.test(postalCode)) {
                error = true;
            }
            break;
        case "CA":
            if (!/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i.test(postalCode)) {
                error = true;
            }
            break;
    }

    return error;
};

export const prepareAddressForValidation = (address: any) => {
    let country = "";
    let state = "";

    if (address.country) {
        if (typeof address.country === "string") {
            country = address.country;
        } else {
            country = address.country?.abbreviation;
        }
    }

    if (address.state) {
        if (typeof address.state === "string") {
            state = address.state;
        } else {
            state = address.state?.abbreviation;
        }
    }

    return {
        addressLine1: address.address1 || "",
        addressLine2: address.address2 || "",
        addressLine3: address.address3 || "",
        city: address.city,
        country,
        postalCode: address.postalCode,
        state,
    };
};

export const isMobileScreen = () => typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches;

export const isTabletScreen = () => typeof window !== "undefined" && window.matchMedia("(max-width: 1024px)").matches;

export const isWideScreen = () => typeof window !== "undefined" && window.matchMedia("(min-width: 2200px)").matches;

export const closeAllTippy = () => {
    [...document.querySelectorAll('[data-tippy-root]')].forEach((node: any) => {
        if (node._tippy && node._tippy?.state?.isVisible && !node._tippy?.state?.isDestroyed) {
            node._tippy.hide();
        }
    });
};